<ng-container>
    <ion-card-content class="ion-no-padding">
        <ion-grid class="team">
            <ion-row class="header">
                <ion-col size="4" size-md="4">
                    {{ 'generic.evaluee' | translate }}
                </ion-col>
                <ion-col size="2" size-md="2">
                    {{ 'generic.dateAdded' | translate }}
                </ion-col>
                <ion-col size="2" size-md="2" *ngIf="freeEvaluationType === FreeEvaluationType.EndYear">
                    {{ 'freeEvaluationEndYear.finalConcept' | translate }}
                </ion-col>
                <ion-col size="2" [sizeMd]="freeEvaluationType === FreeEvaluationType.EndYear ? 2 : 4">
                    {{ 'generic.status' | translate }}
                </ion-col>
                <ion-col size="2" size-md="2" class="align-self-end">
                    {{ 'generic.actions' | translate }}
                </ion-col>
            </ion-row>
            <ion-row *ngFor="let evaluation of evaluations">
                <ion-col class="set-flex ion-align-self-center" size="4" size-md="4">
                    <img
                            [src]="evaluation.subjectUser?.imageUrl"
                            default=""
                            class="avatar"
                            alt=""
                    />
                    <h3>{{ evaluation.subjectUser?.name }}</h3>
                </ion-col>

                <ion-col size="2" size-md="2" class="ion-align-self-center">
                    <h3>{{ evaluation.createdAt }}</h3>
                </ion-col>

                <ion-col size="2" size-md="2" class="ion-align-self-center" *ngIf="freeEvaluationType === FreeEvaluationType.EndYear">
                    <ion-label color="{{ getConcept(evaluation, true) }}">
                        {{ getConcept(evaluation, false) }}
                    </ion-label>
                </ion-col>

                <ion-col size="2" [sizeMd]="freeEvaluationType === FreeEvaluationType.EndYear ? 2 : 4" class="ion-align-self-center">
                    <ion-label color="warning" *ngIf="evaluation.status === FreeEvaluationStatus.NotSent">
                        {{ 'generic.NotSent' | translate }}
                    </ion-label>
                    <ion-label color="success" *ngIf="evaluation.status === FreeEvaluationStatus.Sent">
                        {{ 'generic.Sent' | translate }}
                    </ion-label>
                </ion-col>

                <ion-col size="2" size-md="2" class="actions">
                    <ion-icon color="primary" class="bp-view bigger"
                              (click)="editEvaluation(evaluation, processConfig)"
                    ></ion-icon>
                    <ion-icon color="danger" class="bp-delete bigger"
                              *ngIf="canReopenOrDeleteEvaluation || evaluation.status === FreeEvaluationStatus.NotSent"
                              (click)="confirmDeleteEvaluation(evaluation)"
                    ></ion-icon>
                    <ion-button mode="ios" expand="block" fill="outline"
                                *ngIf="canReopenOrDeleteEvaluation && evaluation.status === FreeEvaluationStatus.Sent"
                                (click)="reopenEvaluation(evaluation)"
                                style="width: min-content">
                        {{ 'processParticipants.reopen' | translate }}
                    </ion-button>
                    <ion-button class="text-wrap" mode="ios" expand="block"
                                *ngIf="canReopenOrDeleteEvaluation && evaluation.status === FreeEvaluationStatus.NotSent"
                                (click)="sendEvaluation(evaluation)"
                                style="width: min-content">
                        <span class="bp-send"></span>
                        &nbsp;
                        <span>{{ 'generic.send' | translate }}</span>
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ng-container>        